const INSTAGRAM_EMBED_SCRIPT = 'https://www.instagram.com/embed.js';

function processInstagramEmbeds() {
  window.instgrm?.Embeds?.process();
}

function loadInstagramEmbedScript() {
  if (!document.querySelector('.annur-social .instagram-media')) return;

  if (window.instgrm?.Embeds) {
    processInstagramEmbeds();
    return;
  }

  if (document.querySelector(`script[src="${INSTAGRAM_EMBED_SCRIPT}"]`)) return;

  const script = document.createElement('script');
  script.src = INSTAGRAM_EMBED_SCRIPT;
  script.async = true;
  script.addEventListener('load', processInstagramEmbeds, { once: true });
  document.head.append(script);
}

if (!window.__annurSocialGalleryInitialized) {
  window.__annurSocialGalleryInitialized = true;
  loadInstagramEmbedScript();
  document.addEventListener('shopify:section:load', loadInstagramEmbedScript);
}
